
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsdcf3e1ce7bb321a31f8ad614e4d4b238en from './en.yaml'
            i18n.addResourceBundle('en', 'dcf3e1ce7bb321a31f8ad614e4d4b238', flattenObject(nsdcf3e1ce7bb321a31f8ad614e4d4b238en), true, true);
        
        export default 'dcf3e1ce7bb321a31f8ad614e4d4b238';
    